export const onboardingTrackerLogs: any = [
  {
    id: 123563,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.764545, -33.4880533],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330433,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123563,
        },
      ],
      timestamp: '2022-11-08T19:38:55',
      altitude: '461.50',
      angle: '247.1',
      satellites: 22,
      place: 'InStation',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123561,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.76272, -33.4880516],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330430,
          value: '8.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123561,
        },
      ],
      timestamp: '2022-11-08T19:37:55',
      altitude: '460.40',
      angle: '306.3',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123558,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.76306, -33.4924383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330425,
          value: '20.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123558,
        },
      ],
      timestamp: '2022-11-08T19:36:55',
      altitude: '461.80',
      angle: '339.7',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123557,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7606383, -33.4922816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330424,
          value: '20.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123557,
        },
      ],
      timestamp: '2022-11-08T19:36:31',
      altitude: '463.70',
      angle: '263.6',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123555,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.754485, -33.4909616],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330421,
          value: '37.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123555,
        },
      ],
      timestamp: '2022-11-08T19:35:31',
      altitude: '471.00',
      angle: '234.4',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123551,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7508716, -33.4869083],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330416,
          value: '27.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123551,
        },
      ],
      timestamp: '2022-11-08T19:34:33',
      altitude: '473.30',
      angle: '36.3',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123550,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.749985, -33.4888933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330415,
          value: '100.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123550,
        },
      ],
      timestamp: '2022-11-08T19:34:17',
      altitude: '473.70',
      angle: '335.5',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123548,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.745175, -33.496975],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330412,
          value: '114.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123548,
        },
      ],
      timestamp: '2022-11-08T19:33:37',
      altitude: '467.80',
      angle: '323.0',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123546,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7369633, -33.5031616],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330409,
          value: '120.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123546,
        },
      ],
      timestamp: '2022-11-08T19:33:04',
      altitude: '479.80',
      angle: '287.9',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123545,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7267133, -33.506455],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330408,
          value: '107.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123545,
        },
      ],
      timestamp: '2022-11-08T19:32:30',
      altitude: '496.40',
      angle: '309.8',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123543,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7191566, -33.5132383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330405,
          value: '104.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123543,
        },
      ],
      timestamp: '2022-11-08T19:31:56',
      altitude: '505.90',
      angle: '312.4',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123542,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7097583, -33.5176816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330404,
          value: '130.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123542,
        },
      ],
      timestamp: '2022-11-08T19:31:24',
      altitude: '515.80',
      angle: '294.0',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123539,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.699935, -33.52193],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330399,
          value: '94.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123539,
        },
      ],
      timestamp: '2022-11-08T19:30:50',
      altitude: '526.80',
      angle: '314.7',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123538,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6913033, -33.5273116],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330398,
          value: '113.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123538,
        },
      ],
      timestamp: '2022-11-08T19:30:12',
      altitude: '533.90',
      angle: '297.9',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123537,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.68179, -33.5317683],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330397,
          value: '125.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123537,
        },
      ],
      timestamp: '2022-11-08T19:29:42',
      altitude: '543.30',
      angle: '293.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123535,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.671345, -33.535105],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330394,
          value: '110.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123535,
        },
      ],
      timestamp: '2022-11-08T19:29:11',
      altitude: '560.00',
      angle: '287.0',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123534,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6608766, -33.5382433],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330393,
          value: '98.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123534,
        },
      ],
      timestamp: '2022-11-08T19:28:34',
      altitude: '569.40',
      angle: '283.9',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123532,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6501516, -33.5401416],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330390,
          value: '98.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123532,
        },
      ],
      timestamp: '2022-11-08T19:27:57',
      altitude: '579.90',
      angle: '281.3',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123531,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.639345, -33.5416383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330389,
          value: '98.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123531,
        },
      ],
      timestamp: '2022-11-08T19:27:21',
      altitude: '587.90',
      angle: '278.6',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123529,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.628615, -33.5428283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330386,
          value: '81.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123529,
        },
      ],
      timestamp: '2022-11-08T19:26:42',
      altitude: '598.90',
      angle: '263.6',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123525,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.617825, -33.5413283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330379,
          value: '94.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123525,
        },
      ],
      timestamp: '2022-11-08T19:25:59',
      altitude: '601.70',
      angle: '255.8',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123524,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6101566, -33.5374816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330378,
          value: '20.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123524,
        },
      ],
      timestamp: '2022-11-08T19:24:59',
      altitude: '604.20',
      angle: '214.5',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123523,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6097833, -33.537455],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330377,
          value: '9.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123523,
        },
      ],
      timestamp: '2022-11-08T19:24:14',
      altitude: '603.20',
      angle: '279.8',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123521,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6089166, -33.53721],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330375,
          value: '10.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123521,
        },
      ],
      timestamp: '2022-11-08T19:23:10',
      altitude: '599.20',
      angle: '314.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123520,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6089566, -33.537305],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330374,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123520,
        },
      ],
      timestamp: '2022-11-08T19:22:36',
      altitude: '600.00',
      angle: '37.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123519,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6089583, -33.537305],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330373,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123519,
        },
      ],
      timestamp: '2022-11-08T19:21:36',
      altitude: '599.90',
      angle: '37.4',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123518,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.60896, -33.537305],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330372,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123518,
        },
      ],
      timestamp: '2022-11-08T19:20:37',
      altitude: '600.00',
      angle: '37.4',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123517,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6089716, -33.5373266],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330371,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123517,
        },
      ],
      timestamp: '2022-11-08T19:19:36',
      altitude: '600.60',
      angle: '30.6',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123516,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6089716, -33.5375633],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330370,
          value: '19.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123516,
        },
      ],
      timestamp: '2022-11-08T19:18:36',
      altitude: '601.10',
      angle: '347.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123515,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.60575, -33.5385516],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330369,
          value: '23.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123515,
        },
      ],
      timestamp: '2022-11-08T19:17:57',
      altitude: '605.40',
      angle: '287.8',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123514,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6029933, -33.5391816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330368,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123514,
        },
      ],
      timestamp: '2022-11-08T19:16:57',
      altitude: '606.90',
      angle: '274.9',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123513,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5979616, -33.5392866],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330367,
          value: '40.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123513,
        },
      ],
      timestamp: '2022-11-08T19:15:57',
      altitude: '609.10',
      angle: '271.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123512,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5919383, -33.539505],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330366,
          value: '41.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123512,
        },
      ],
      timestamp: '2022-11-08T19:14:57',
      altitude: '614.30',
      angle: '271.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123511,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5863216, -33.53966],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330365,
          value: '41.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123511,
        },
      ],
      timestamp: '2022-11-08T19:13:57',
      altitude: '614.60',
      angle: '270.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123510,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5854733, -33.5396533],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330364,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123510,
        },
      ],
      timestamp: '2022-11-08T19:12:57',
      altitude: '615.20',
      angle: '269.6',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123509,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5834016, -33.5397],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330363,
          value: '34.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123509,
        },
      ],
      timestamp: '2022-11-08T19:11:57',
      altitude: '614.50',
      angle: '270.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123508,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5828433, -33.5401566],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330362,
          value: '4.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123508,
        },
      ],
      timestamp: '2022-11-08T19:11:27',
      altitude: '618.00',
      angle: '330.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123507,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5790333, -33.5472],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330361,
          value: '19.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123507,
        },
      ],
      timestamp: '2022-11-08T19:10:27',
      altitude: '628.60',
      angle: '342.4',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123506,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.575635, -33.547345],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330360,
          value: '44.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123506,
        },
      ],
      timestamp: '2022-11-08T19:09:51',
      altitude: '629.10',
      angle: '272.5',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123505,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5683616, -33.547525],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330359,
          value: '41.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123505,
        },
      ],
      timestamp: '2022-11-08T19:08:51',
      altitude: '636.40',
      angle: '272.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123504,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5660983, -33.5476166],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330358,
          value: '43.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123504,
        },
      ],
      timestamp: '2022-11-08T19:07:51',
      altitude: '637.70',
      angle: '271.4',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123503,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5578733, -33.5478416],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330357,
          value: '12.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123503,
        },
      ],
      timestamp: '2022-11-08T19:06:51',
      altitude: '640.30',
      angle: '289.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123502,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.557835, -33.548635],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330356,
          value: '21.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123502,
        },
      ],
      timestamp: '2022-11-08T19:06:23',
      altitude: '641.40',
      angle: '0.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123500,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.555415, -33.5497083],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330354,
          value: '7.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123500,
        },
      ],
      timestamp: '2022-11-08T19:05:10',
      altitude: '653.20',
      angle: '67.3',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123499,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5555833, -33.54972],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330353,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123499,
        },
      ],
      timestamp: '2022-11-08T19:04:10',
      altitude: '653.40',
      angle: '85.0',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123498,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.55796, -33.5493916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330352,
          value: '3.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123498,
        },
      ],
      timestamp: '2022-11-08T19:03:09',
      altitude: '648.50',
      angle: '91.9',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123497,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5637666, -33.549215],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330351,
          value: '30.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123497,
        },
      ],
      timestamp: '2022-11-08T19:02:09',
      altitude: '642.50',
      angle: '88.5',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123496,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5659083, -33.5499983],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330350,
          value: '8.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123496,
        },
      ],
      timestamp: '2022-11-08T19:01:09',
      altitude: '643.10',
      angle: '45.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123495,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.56428, -33.5522483],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330349,
          value: '18.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123495,
        },
      ],
      timestamp: '2022-11-08T19:00:19',
      altitude: '647.00',
      angle: '336.5',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123494,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.56432, -33.5524166],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330348,
          value: '15.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123494,
        },
      ],
      timestamp: '2022-11-08T19:00:15',
      altitude: '647.20',
      angle: '47.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123493,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5671816, -33.5525933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330347,
          value: '20.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123493,
        },
      ],
      timestamp: '2022-11-08T18:59:15',
      altitude: '643.20',
      angle: '86.6',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123492,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5713433, -33.5528183],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330346,
          value: '18.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123492,
        },
      ],
      timestamp: '2022-11-08T18:58:14',
      altitude: '642.40',
      angle: '86.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123491,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.57616, -33.55302],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330345,
          value: '38.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123491,
        },
      ],
      timestamp: '2022-11-08T18:57:14',
      altitude: '639.60',
      angle: '88.7',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123490,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5811983, -33.5531516],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330344,
          value: '18.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123490,
        },
      ],
      timestamp: '2022-11-08T18:56:14',
      altitude: '641.40',
      angle: '80.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123489,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5810183, -33.5550383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330343,
          value: '41.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123489,
        },
      ],
      timestamp: '2022-11-08T18:55:47',
      altitude: '643.00',
      angle: '356.8',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123488,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5857983, -33.5565483],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330342,
          value: '17.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123488,
        },
      ],
      timestamp: '2022-11-08T18:54:54',
      altitude: '646.00',
      angle: '61.1',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123487,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5850533, -33.5611016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330341,
          value: '48.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123487,
        },
      ],
      timestamp: '2022-11-08T18:54:02',
      altitude: '651.20',
      angle: '351.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123486,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5842566, -33.565875],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330340,
          value: '27.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123486,
        },
      ],
      timestamp: '2022-11-08T18:53:02',
      altitude: '654.50',
      angle: '14.3',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123485,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5848083, -33.566035],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330339,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123485,
        },
      ],
      timestamp: '2022-11-08T18:52:40',
      altitude: '651.80',
      angle: '82.9',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123484,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5848083, -33.566035],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330338,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123484,
        },
      ],
      timestamp: '2022-11-08T18:51:40',
      altitude: '651.80',
      angle: '82.9',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123483,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5894533, -33.5666516],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330337,
          value: '19.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123483,
        },
      ],
      timestamp: '2022-11-08T18:50:40',
      altitude: '649.20',
      angle: '86.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123482,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5897633, -33.56558],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330336,
          value: '19.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123482,
        },
      ],
      timestamp: '2022-11-08T18:50:19',
      altitude: '647.50',
      angle: '161.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123481,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5911133, -33.56566],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330335,
          value: '41.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123481,
        },
      ],
      timestamp: '2022-11-08T18:50:00',
      altitude: '646.70',
      angle: '80.5',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123480,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.59643, -33.566155],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330334,
          value: '6.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123480,
        },
      ],
      timestamp: '2022-11-08T18:49:00',
      altitude: '645.30',
      angle: '115.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123479,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.59801, -33.5663366],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330333,
          value: '9.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123479,
        },
      ],
      timestamp: '2022-11-08T18:48:26',
      altitude: '643.80',
      angle: '54.2',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123478,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.5978083, -33.5681566],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330332,
          value: '31.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123478,
        },
      ],
      timestamp: '2022-11-08T18:47:56',
      altitude: '646.60',
      angle: '351.9',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123476,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.59927, -33.5729666],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330330,
          value: '37.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123476,
        },
      ],
      timestamp: '2022-11-08T18:46:58',
      altitude: '651.70',
      angle: '350.7',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123474,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.598455, -33.57836],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330328,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123474,
        },
      ],
      timestamp: '2022-11-08T18:45:47',
      altitude: '656.70',
      angle: '80.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123472,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6028566, -33.5821483],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330326,
          value: '17.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123472,
        },
      ],
      timestamp: '2022-11-08T18:43:57',
      altitude: '654.80',
      angle: '12.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123470,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6102866, -33.5832616],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330324,
          value: '35.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123470,
        },
      ],
      timestamp: '2022-11-08T18:42:10',
      altitude: '652.90',
      angle: '81.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123469,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.612455, -33.5835183],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330323,
          value: '23.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123469,
        },
      ],
      timestamp: '2022-11-08T18:41:09',
      altitude: '648.20',
      angle: '81.2',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123468,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.620615, -33.5846266],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330322,
          value: '16.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123468,
        },
      ],
      timestamp: '2022-11-08T18:40:09',
      altitude: '642.90',
      angle: '79.1',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123467,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.628335, -33.5857033],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330321,
          value: '15.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123467,
        },
      ],
      timestamp: '2022-11-08T18:39:09',
      altitude: '636.20',
      angle: '56.5',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123466,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6283333, -33.586155],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330320,
          value: '3.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123466,
        },
      ],
      timestamp: '2022-11-08T18:38:17',
      altitude: '637.00',
      angle: '353.9',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123465,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6280266, -33.5889433],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330319,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123465,
        },
      ],
      timestamp: '2022-11-08T18:37:17',
      altitude: '642.60',
      angle: '349.8',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123463,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6277483, -33.5918283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330317,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123463,
        },
      ],
      timestamp: '2022-11-08T18:36:17',
      altitude: '646.80',
      angle: '352.5',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123461,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6274966, -33.59453],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330315,
          value: '45.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123461,
        },
      ],
      timestamp: '2022-11-08T18:35:17',
      altitude: '648.40',
      angle: '356.5',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123460,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.62743, -33.5953866],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330314,
          value: '7.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123460,
        },
      ],
      timestamp: '2022-11-08T18:34:17',
      altitude: '648.50',
      angle: '355.7',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123459,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6271566, -33.5984766],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330313,
          value: '33.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123459,
        },
      ],
      timestamp: '2022-11-08T18:33:17',
      altitude: '649.40',
      angle: '355.0',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123458,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.627135, -33.6005766],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330312,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123458,
        },
      ],
      timestamp: '2022-11-08T18:32:17',
      altitude: '651.10',
      angle: '13.6',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123456,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6271566, -33.607975],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330310,
          value: '12.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123456,
        },
      ],
      timestamp: '2022-11-08T18:31:08',
      altitude: '655.50',
      angle: '61.6',
      satellites: 14,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123455,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.62718, -33.6080066],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330309,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123455,
        },
      ],
      timestamp: '2022-11-08T18:30:25',
      altitude: '655.40',
      angle: '0.0',
      satellites: 5,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123454,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6271483, -33.6084783],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330308,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123454,
        },
      ],
      timestamp: '2022-11-08T18:24:30',
      altitude: '659.40',
      angle: '329.7',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123453,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6271483, -33.6084783],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330307,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123453,
        },
      ],
      timestamp: '2022-11-08T18:23:30',
      altitude: '659.40',
      angle: '329.7',
      satellites: 14,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123451,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.627355, -33.6079733],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330305,
          value: '14.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123451,
        },
      ],
      timestamp: '2022-11-08T18:22:21',
      altitude: '664.80',
      angle: '88.2',
      satellites: 6,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123448,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.62783, -33.6086866],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330302,
          value: '20.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123448,
        },
      ],
      timestamp: '2022-11-08T18:22:00',
      altitude: '697.80',
      angle: '91.3',
      satellites: 5,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123444,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6310733, -33.6081533],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330298,
          value: '8.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123444,
        },
      ],
      timestamp: '2022-11-08T18:17:54',
      altitude: '646.50',
      angle: '84.4',
      satellites: 5,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123443,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325833, -33.6079933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330297,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123443,
        },
      ],
      timestamp: '2022-11-08T18:11:24',
      altitude: '637.10',
      angle: '333.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123442,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325833, -33.6079933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330296,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123442,
        },
      ],
      timestamp: '2022-11-08T18:10:24',
      altitude: '637.10',
      angle: '333.2',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123441,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325833, -33.6079933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330295,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123441,
        },
      ],
      timestamp: '2022-11-08T18:09:24',
      altitude: '637.10',
      angle: '333.2',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123440,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325833, -33.6079933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330294,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123440,
        },
      ],
      timestamp: '2022-11-08T18:08:24',
      altitude: '637.10',
      angle: '333.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123439,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325833, -33.6079933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330293,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123439,
        },
      ],
      timestamp: '2022-11-08T18:07:24',
      altitude: '637.10',
      angle: '333.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123438,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325833, -33.6079933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330292,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123438,
        },
      ],
      timestamp: '2022-11-08T18:06:24',
      altitude: '637.10',
      angle: '333.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123437,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325833, -33.6079933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330291,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123437,
        },
      ],
      timestamp: '2022-11-08T18:05:24',
      altitude: '637.10',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123436,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325833, -33.6079933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330290,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123436,
        },
      ],
      timestamp: '2022-11-08T18:04:24',
      altitude: '637.10',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123435,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325833, -33.6079933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330289,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123435,
        },
      ],
      timestamp: '2022-11-08T18:03:24',
      altitude: '637.10',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123434,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325833, -33.6079933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330288,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123434,
        },
      ],
      timestamp: '2022-11-08T18:02:24',
      altitude: '637.10',
      angle: '333.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123433,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325816, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330287,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123433,
        },
      ],
      timestamp: '2022-11-08T18:01:24',
      altitude: '636.40',
      angle: '333.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123432,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325816, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330286,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123432,
        },
      ],
      timestamp: '2022-11-08T18:00:24',
      altitude: '636.40',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123431,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325816, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330285,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123431,
        },
      ],
      timestamp: '2022-11-08T17:59:24',
      altitude: '636.40',
      angle: '333.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123430,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325816, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330284,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123430,
        },
      ],
      timestamp: '2022-11-08T17:58:24',
      altitude: '636.40',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123429,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325816, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330283,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123429,
        },
      ],
      timestamp: '2022-11-08T17:57:24',
      altitude: '636.40',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123428,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63258, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330282,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123428,
        },
      ],
      timestamp: '2022-11-08T17:56:24',
      altitude: '636.10',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123427,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63258, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330281,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123427,
        },
      ],
      timestamp: '2022-11-08T17:55:23',
      altitude: '636.10',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123426,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63258, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330280,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123426,
        },
      ],
      timestamp: '2022-11-08T17:54:23',
      altitude: '636.10',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123425,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63258, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330279,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123425,
        },
      ],
      timestamp: '2022-11-08T17:53:23',
      altitude: '636.10',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123424,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63258, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330278,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123424,
        },
      ],
      timestamp: '2022-11-08T17:52:23',
      altitude: '636.10',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123423,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63258, -33.6079916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330277,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123423,
        },
      ],
      timestamp: '2022-11-08T17:51:23',
      altitude: '636.10',
      angle: '333.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123422,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6325316, -33.6078683],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330276,
          value: '14.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123422,
        },
      ],
      timestamp: '2022-11-08T17:50:23',
      altitude: '636.10',
      angle: '208.1',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123420,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.62879, -33.6076816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330274,
          value: '5.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123420,
        },
      ],
      timestamp: '2022-11-08T17:49:24',
      altitude: '641.40',
      angle: '94.6',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123419,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6274783, -33.6078416],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330273,
          value: '12.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123419,
        },
      ],
      timestamp: '2022-11-08T17:48:54',
      altitude: '643.40',
      angle: '275.4',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123418,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6270516, -33.6078233],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330272,
          value: '11.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123418,
        },
      ],
      timestamp: '2022-11-08T17:47:54',
      altitude: '643.10',
      angle: '244.0',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123417,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6271966, -33.6045416],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330271,
          value: '35.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123417,
        },
      ],
      timestamp: '2022-11-08T17:47:19',
      altitude: '641.60',
      angle: '178.0',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123416,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6275883, -33.5968116],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330270,
          value: '62.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123416,
        },
      ],
      timestamp: '2022-11-08T17:46:19',
      altitude: '636.30',
      angle: '175.9',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123415,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6279266, -33.5932366],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330269,
          value: '55.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123415,
        },
      ],
      timestamp: '2022-11-08T17:45:54',
      altitude: '635.00',
      angle: '176.1',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123414,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.62836, -33.5891316],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330268,
          value: '50.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123414,
        },
      ],
      timestamp: '2022-11-08T17:45:19',
      altitude: '633.50',
      angle: '176.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123413,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6286416, -33.58567],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330267,
          value: '2.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123413,
        },
      ],
      timestamp: '2022-11-08T17:44:19',
      altitude: '631.00',
      angle: '226.4',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123412,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6282066, -33.5855966],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330266,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123412,
        },
      ],
      timestamp: '2022-11-08T17:43:19',
      altitude: '630.30',
      angle: '260.4',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123411,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.61929, -33.5843583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330265,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123411,
        },
      ],
      timestamp: '2022-11-08T17:42:19',
      altitude: '638.80',
      angle: '255.8',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123409,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6112083, -33.5819583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330263,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123409,
        },
      ],
      timestamp: '2022-11-08T17:40:36',
      altitude: '644.20',
      angle: '175.7',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123408,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6112333, -33.581845],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330262,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123408,
        },
      ],
      timestamp: '2022-11-08T17:39:36',
      altitude: '644.00',
      angle: '189.3',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123407,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.611235, -33.5818433],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330261,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123407,
        },
      ],
      timestamp: '2022-11-08T17:38:36',
      altitude: '643.90',
      angle: '189.3',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123406,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6115616, -33.5786466],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330260,
          value: '77.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123406,
        },
      ],
      timestamp: '2022-11-08T17:37:36',
      altitude: '642.50',
      angle: '174.5',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123404,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6145616, -33.56281],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330258,
          value: '95.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123404,
        },
      ],
      timestamp: '2022-11-08T17:36:31',
      altitude: '590.30',
      angle: '162.8',
      satellites: 6,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123403,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6153033, -33.5605983],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330257,
          value: '88.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123403,
        },
      ],
      timestamp: '2022-11-08T17:36:21',
      altitude: '612.30',
      angle: '166.5',
      satellites: 8,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123400,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6183216, -33.5471716],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330254,
          value: '71.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123400,
        },
      ],
      timestamp: '2022-11-08T17:35:22',
      altitude: '627.00',
      angle: '162.9',
      satellites: 7,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123399,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6192316, -33.54548],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330253,
          value: '42.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123399,
        },
      ],
      timestamp: '2022-11-08T17:35:12',
      altitude: '605.70',
      angle: '168.3',
      satellites: 5,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123397,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6205033, -33.54275],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330251,
          value: '55.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123397,
        },
      ],
      timestamp: '2022-11-08T17:34:51',
      altitude: '601.00',
      angle: '145.1',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123396,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6251166, -33.5425566],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330250,
          value: '65.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123396,
        },
      ],
      timestamp: '2022-11-08T17:34:21',
      altitude: '603.60',
      angle: '81.0',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123395,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6359016, -33.542275],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330249,
          value: '101.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123395,
        },
      ],
      timestamp: '2022-11-08T17:33:39',
      altitude: '588.40',
      angle: '97.7',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123394,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6467, -33.540805],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330248,
          value: '95.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123394,
        },
      ],
      timestamp: '2022-11-08T17:33:02',
      altitude: '586.20',
      angle: '99.9',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123393,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.65737, -33.5390216],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330247,
          value: '95.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123393,
        },
      ],
      timestamp: '2022-11-08T17:32:25',
      altitude: '575.70',
      angle: '101.8',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123392,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6678916, -33.5363633],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330246,
          value: '96.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123392,
        },
      ],
      timestamp: '2022-11-08T17:31:48',
      altitude: '565.30',
      angle: '110.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123391,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6783166, -33.5331783],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330245,
          value: '100.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123391,
        },
      ],
      timestamp: '2022-11-08T17:31:09',
      altitude: '556.70',
      angle: '112.7',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123390,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.68801, -33.5289716],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330244,
          value: '85.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123390,
        },
      ],
      timestamp: '2022-11-08T17:30:32',
      altitude: '539.20',
      angle: '119.5',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123389,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.697425, -33.5243583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330243,
          value: '79.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123389,
        },
      ],
      timestamp: '2022-11-08T17:29:49',
      altitude: '529.80',
      angle: '134.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123387,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7049783, -33.52013],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330241,
          value: '21.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123387,
        },
      ],
      timestamp: '2022-11-08T17:28:35',
      altitude: '524.20',
      angle: '39.3',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123385,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7046433, -33.52076],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330239,
          value: '20.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123385,
        },
      ],
      timestamp: '2022-11-08T17:28:20',
      altitude: '528.80',
      angle: '272.3',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123384,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.704115, -33.5203816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330238,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123384,
        },
      ],
      timestamp: '2022-11-08T17:28:02',
      altitude: '529.60',
      angle: '205.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123382,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6983366, -33.508415],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330236,
          value: '119.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123382,
        },
      ],
      timestamp: '2022-11-08T17:26:27',
      altitude: '521.40',
      angle: '202.5',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123381,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6942566, -33.5000483],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330235,
          value: '117.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123381,
        },
      ],
      timestamp: '2022-11-08T17:25:55',
      altitude: '518.80',
      angle: '202.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123380,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6902933, -33.4915366],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330234,
          value: '120.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123380,
        },
      ],
      timestamp: '2022-11-08T17:25:23',
      altitude: '518.20',
      angle: '198.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123379,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6867216, -33.4829316],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330233,
          value: '93.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123379,
        },
      ],
      timestamp: '2022-11-08T17:24:50',
      altitude: '515.70',
      angle: '198.6',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123378,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6877283, -33.4739516],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330232,
          value: '73.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123378,
        },
      ],
      timestamp: '2022-11-08T17:24:05',
      altitude: '521.50',
      angle: '155.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123376,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6880783, -33.4647816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330230,
          value: '102.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123376,
        },
      ],
      timestamp: '2022-11-08T17:23:21',
      altitude: '516.20',
      angle: '175.3',
      satellites: 12,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123371,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.68912, -33.4594866],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330225,
          value: '98.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123371,
        },
      ],
      timestamp: '2022-11-08T17:23:01',
      altitude: '515.20',
      angle: '166.0',
      satellites: 6,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123369,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.690405, -33.4556016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330223,
          value: '109.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123369,
        },
      ],
      timestamp: '2022-11-08T17:22:46',
      altitude: '516.10',
      angle: '164.9',
      satellites: 7,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123361,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6914383, -33.4174283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330215,
          value: '79.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123361,
        },
      ],
      timestamp: '2022-11-08T17:20:15',
      altitude: '524.20',
      angle: '164.5',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123360,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6940533, -33.408545],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330214,
          value: '87.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123360,
        },
      ],
      timestamp: '2022-11-08T17:19:29',
      altitude: '501.40',
      angle: '161.8',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123359,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6979666, -33.3999983],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330213,
          value: '110.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123359,
        },
      ],
      timestamp: '2022-11-08T17:18:48',
      altitude: '497.90',
      angle: '156.0',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123358,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6999016, -33.39091],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330212,
          value: '82.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123358,
        },
      ],
      timestamp: '2022-11-08T17:18:02',
      altitude: '500.90',
      angle: '202.3',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123357,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.69576, -33.3823866],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330211,
          value: '82.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123357,
        },
      ],
      timestamp: '2022-11-08T17:17:18',
      altitude: '513.30',
      angle: '204.3',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123356,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6971566, -33.3733616],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330210,
          value: '81.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123356,
        },
      ],
      timestamp: '2022-11-08T17:16:20',
      altitude: '494.70',
      angle: '162.5',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123353,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.701435, -33.366055],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330207,
          value: '32.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123353,
        },
      ],
      timestamp: '2022-11-08T17:15:19',
      altitude: '501.90',
      angle: '323.5',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123352,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6996266, -33.3658916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330206,
          value: '23.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123352,
        },
      ],
      timestamp: '2022-11-08T17:14:52',
      altitude: '503.30',
      angle: '259.9',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123351,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6909916, -33.36593],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330205,
          value: '71.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123351,
        },
      ],
      timestamp: '2022-11-08T17:13:52',
      altitude: '504.50',
      angle: '275.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123350,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.680265, -33.36758],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330204,
          value: '98.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123350,
        },
      ],
      timestamp: '2022-11-08T17:13:05',
      altitude: '499.60',
      angle: '295.9',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123349,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6701983, -33.37135],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330203,
          value: '103.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123349,
        },
      ],
      timestamp: '2022-11-08T17:12:30',
      altitude: '498.00',
      angle: '292.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123348,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.660325, -33.3750233],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330202,
          value: '124.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123348,
        },
      ],
      timestamp: '2022-11-08T17:11:57',
      altitude: '507.40',
      angle: '294.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123347,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.650425, -33.3787083],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330201,
          value: '112.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123347,
        },
      ],
      timestamp: '2022-11-08T17:11:26',
      altitude: '510.60',
      angle: '292.3',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123346,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.64075, -33.38276],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330200,
          value: '30.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123346,
        },
      ],
      timestamp: '2022-11-08T17:10:34',
      altitude: '516.60',
      angle: '288.8',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123345,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6386866, -33.3787216],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330199,
          value: '25.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123345,
        },
      ],
      timestamp: '2022-11-08T17:09:35',
      altitude: '520.80',
      angle: '224.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123344,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63465, -33.3790116],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330198,
          value: '8.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123344,
        },
      ],
      timestamp: '2022-11-08T17:08:43',
      altitude: '527.20',
      angle: '300.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123342,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6346216, -33.37913],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330196,
          value: '4.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123342,
        },
      ],
      timestamp: '2022-11-08T17:08:21',
      altitude: '525.60',
      angle: '101.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123341,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6346316, -33.3791616],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330195,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123341,
        },
      ],
      timestamp: '2022-11-08T17:07:45',
      altitude: '524.30',
      angle: '186.8',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123340,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6346366, -33.379165],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330194,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123340,
        },
      ],
      timestamp: '2022-11-08T17:06:45',
      altitude: '522.10',
      angle: '186.8',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123339,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6346366, -33.379165],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330193,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123339,
        },
      ],
      timestamp: '2022-11-08T17:05:45',
      altitude: '522.10',
      angle: '186.8',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123338,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6346366, -33.379165],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330192,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123338,
        },
      ],
      timestamp: '2022-11-08T17:04:45',
      altitude: '522.10',
      angle: '186.8',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123337,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6346366, -33.379165],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330191,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123337,
        },
      ],
      timestamp: '2022-11-08T17:03:45',
      altitude: '522.10',
      angle: '186.8',
      satellites: 14,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123336,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6346716, -33.3790816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330190,
          value: '9.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123336,
        },
      ],
      timestamp: '2022-11-08T17:02:45',
      altitude: '520.70',
      angle: '154.5',
      satellites: 12,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123334,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6378433, -33.3789583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330188,
          value: '4.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123334,
        },
      ],
      timestamp: '2022-11-08T17:02:01',
      altitude: '522.70',
      angle: '29.2',
      satellites: 12,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123333,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6379266, -33.3791166],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330187,
          value: '10.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123333,
        },
      ],
      timestamp: '2022-11-08T17:01:43',
      altitude: '522.60',
      angle: '352.2',
      satellites: 12,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123330,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6349416, -33.3796283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330185,
          value: '23.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123330,
        },
      ],
      timestamp: '2022-11-08T17:01:01',
      altitude: '520.70',
      angle: '278.1',
      satellites: 7,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123331,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6349416, -33.3796283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330184,
          value: '23.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123331,
        },
      ],
      timestamp: '2022-11-08T17:01:01',
      altitude: '520.70',
      angle: '278.1',
      satellites: 7,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123329,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6335116, -33.3796383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330183,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123329,
        },
      ],
      timestamp: '2022-11-08T16:31:52',
      altitude: '513.20',
      angle: '55.3',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123328,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6335116, -33.3796383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330182,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123328,
        },
      ],
      timestamp: '2022-11-08T16:30:52',
      altitude: '513.20',
      angle: '55.3',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123327,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6335116, -33.3796383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330181,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123327,
        },
      ],
      timestamp: '2022-11-08T16:29:52',
      altitude: '513.20',
      angle: '55.3',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123326,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6335116, -33.3796383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330180,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123326,
        },
      ],
      timestamp: '2022-11-08T16:28:52',
      altitude: '513.20',
      angle: '55.3',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123325,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6335116, -33.3796383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330179,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123325,
        },
      ],
      timestamp: '2022-11-08T16:27:52',
      altitude: '513.20',
      angle: '55.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123324,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6335116, -33.3796383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330178,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123324,
        },
      ],
      timestamp: '2022-11-08T16:26:52',
      altitude: '513.20',
      angle: '55.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123323,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6335116, -33.3796383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330177,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123323,
        },
      ],
      timestamp: '2022-11-08T16:25:52',
      altitude: '513.20',
      angle: '55.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123322,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6335116, -33.3796383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330176,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123322,
        },
      ],
      timestamp: '2022-11-08T16:24:52',
      altitude: '513.20',
      angle: '55.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123321,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6335116, -33.3796383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330175,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123321,
        },
      ],
      timestamp: '2022-11-08T16:23:52',
      altitude: '513.20',
      angle: '55.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123320,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6335116, -33.3796383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330174,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123320,
        },
      ],
      timestamp: '2022-11-08T16:22:52',
      altitude: '513.20',
      angle: '55.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123319,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6334716, -33.3798016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330173,
          value: '13.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123319,
        },
      ],
      timestamp: '2022-11-08T16:21:52',
      altitude: '513.70',
      angle: '3.4',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123318,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6350833, -33.3800366],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330172,
          value: '23.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123318,
        },
      ],
      timestamp: '2022-11-08T16:21:26',
      altitude: '515.30',
      angle: '74.9',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123317,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6383316, -33.3795216],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330171,
          value: '19.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123317,
        },
      ],
      timestamp: '2022-11-08T16:20:40',
      altitude: '513.70',
      angle: '138.6',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123316,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6379383, -33.37896],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330170,
          value: '6.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123316,
        },
      ],
      timestamp: '2022-11-08T16:19:59',
      altitude: '516.20',
      angle: '213.8',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123314,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6385916, -33.3787466],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330168,
          value: '19.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123314,
        },
      ],
      timestamp: '2022-11-08T16:18:57',
      altitude: '513.50',
      angle: '53.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123313,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6391983, -33.3801783],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330167,
          value: '17.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123313,
        },
      ],
      timestamp: '2022-11-08T16:18:21',
      altitude: '513.40',
      angle: '346.7',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123311,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63837, -33.3804833],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330165,
          value: '10.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123311,
        },
      ],
      timestamp: '2022-11-08T16:17:30',
      altitude: '513.80',
      angle: '346.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123309,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6392616, -33.380315],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330163,
          value: '20.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123309,
        },
      ],
      timestamp: '2022-11-08T16:17:12',
      altitude: '514.00',
      angle: '141.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123308,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6387666, -33.3787916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330162,
          value: '30.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123308,
        },
      ],
      timestamp: '2022-11-08T16:16:29',
      altitude: '516.80',
      angle: '208.8',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123307,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63811, -33.3787016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330161,
          value: '27.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123307,
        },
      ],
      timestamp: '2022-11-08T16:15:38',
      altitude: '517.80',
      angle: '273.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123306,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369283, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330160,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123306,
        },
      ],
      timestamp: '2022-11-08T16:14:38',
      altitude: '519.80',
      angle: '271.3',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123305,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369316, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330159,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123305,
        },
      ],
      timestamp: '2022-11-08T16:13:38',
      altitude: '519.70',
      angle: '316.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123304,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369316, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330158,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123304,
        },
      ],
      timestamp: '2022-11-08T16:12:38',
      altitude: '520.10',
      angle: '316.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123303,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369283, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330157,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123303,
        },
      ],
      timestamp: '2022-11-08T16:11:38',
      altitude: '520.60',
      angle: '339.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123302,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369283, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330156,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123302,
        },
      ],
      timestamp: '2022-11-08T16:10:39',
      altitude: '520.90',
      angle: '339.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123301,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369266, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330155,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123301,
        },
      ],
      timestamp: '2022-11-08T16:09:38',
      altitude: '521.70',
      angle: '339.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123300,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369266, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330154,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123300,
        },
      ],
      timestamp: '2022-11-08T16:08:38',
      altitude: '521.70',
      angle: '339.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123299,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369266, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330153,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123299,
        },
      ],
      timestamp: '2022-11-08T16:07:38',
      altitude: '521.70',
      angle: '339.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123298,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.636925, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330152,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123298,
        },
      ],
      timestamp: '2022-11-08T16:06:38',
      altitude: '522.40',
      angle: '339.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123297,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.636925, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330151,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123297,
        },
      ],
      timestamp: '2022-11-08T16:05:38',
      altitude: '522.80',
      angle: '339.3',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123296,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.636925, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330150,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123296,
        },
      ],
      timestamp: '2022-11-08T16:04:38',
      altitude: '522.80',
      angle: '339.3',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123295,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.636925, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330149,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123295,
        },
      ],
      timestamp: '2022-11-08T16:03:38',
      altitude: '522.80',
      angle: '339.3',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123294,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.636925, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330148,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123294,
        },
      ],
      timestamp: '2022-11-08T16:02:38',
      altitude: '522.80',
      angle: '339.3',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123293,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.636925, -33.378905],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330147,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123293,
        },
      ],
      timestamp: '2022-11-08T16:01:38',
      altitude: '522.80',
      angle: '339.3',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123292,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369233, -33.3789066],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330146,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123292,
        },
      ],
      timestamp: '2022-11-08T16:00:38',
      altitude: '523.70',
      angle: '339.3',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123291,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369233, -33.3789066],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330145,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123291,
        },
      ],
      timestamp: '2022-11-08T15:59:38',
      altitude: '523.70',
      angle: '339.3',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123290,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369233, -33.3789066],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330144,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123290,
        },
      ],
      timestamp: '2022-11-08T15:58:37',
      altitude: '523.70',
      angle: '339.3',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123289,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369183, -33.3789133],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330143,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123289,
        },
      ],
      timestamp: '2022-11-08T15:57:37',
      altitude: '526.10',
      angle: '279.0',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123288,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369183, -33.3789133],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330142,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123288,
        },
      ],
      timestamp: '2022-11-08T15:56:37',
      altitude: '526.10',
      angle: '279.0',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123287,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6369183, -33.378915],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330141,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123287,
        },
      ],
      timestamp: '2022-11-08T15:55:37',
      altitude: '526.80',
      angle: '279.0',
      satellites: 15,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123286,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.636915, -33.3789183],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330140,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123286,
        },
      ],
      timestamp: '2022-11-08T15:54:37',
      altitude: '528.70',
      angle: '279.0',
      satellites: 14,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123284,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6368116, -33.3789816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330138,
          value: '9.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123284,
        },
      ],
      timestamp: '2022-11-08T15:53:33',
      altitude: '527.60',
      angle: '20.6',
      satellites: 12,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123283,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6385183, -33.37873],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330137,
          value: '18.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123283,
        },
      ],
      timestamp: '2022-11-08T15:52:53',
      altitude: '524.80',
      angle: '91.7',
      satellites: 11,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123281,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63928, -33.38022],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330135,
          value: '11.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123281,
        },
      ],
      timestamp: '2022-11-08T15:52:15',
      altitude: '523.20',
      angle: '95.1',
      satellites: 11,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123279,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6385583, -33.3783316],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330133,
          value: '19.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123279,
        },
      ],
      timestamp: '2022-11-08T15:51:16',
      altitude: '528.50',
      angle: '179.4',
      satellites: 11,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123275,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388633, -33.378105],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330130,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123275,
        },
      ],
      timestamp: '2022-11-08T15:50:18',
      altitude: '517.10',
      angle: '0.0',
      satellites: 6,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123274,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388716, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330128,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123274,
        },
      ],
      timestamp: '2022-11-08T15:41:03',
      altitude: '511.70',
      angle: '12.2',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123273,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388716, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330127,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123273,
        },
      ],
      timestamp: '2022-11-08T15:40:03',
      altitude: '511.50',
      angle: '12.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123272,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388716, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330126,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123272,
        },
      ],
      timestamp: '2022-11-08T15:39:02',
      altitude: '511.50',
      angle: '12.2',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123271,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63887, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330125,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123271,
        },
      ],
      timestamp: '2022-11-08T15:38:02',
      altitude: '510.70',
      angle: '12.2',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123270,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63887, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330124,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123270,
        },
      ],
      timestamp: '2022-11-08T15:37:02',
      altitude: '510.70',
      angle: '12.2',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123269,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63887, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330123,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123269,
        },
      ],
      timestamp: '2022-11-08T15:36:01',
      altitude: '510.40',
      angle: '12.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123268,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63887, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330122,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123268,
        },
      ],
      timestamp: '2022-11-08T15:35:01',
      altitude: '510.40',
      angle: '12.2',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123267,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330121,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123267,
        },
      ],
      timestamp: '2022-11-08T15:34:01',
      altitude: '510.10',
      angle: '12.2',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123266,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330120,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123266,
        },
      ],
      timestamp: '2022-11-08T15:33:00',
      altitude: '510.10',
      angle: '12.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123265,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330119,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123265,
        },
      ],
      timestamp: '2022-11-08T15:32:00',
      altitude: '510.10',
      angle: '12.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123264,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330118,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123264,
        },
      ],
      timestamp: '2022-11-08T15:31:00',
      altitude: '510.10',
      angle: '12.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123263,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330117,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123263,
        },
      ],
      timestamp: '2022-11-08T15:30:00',
      altitude: '510.10',
      angle: '12.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123262,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330116,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123262,
        },
      ],
      timestamp: '2022-11-08T15:29:00',
      altitude: '510.10',
      angle: '12.2',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123261,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330115,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123261,
        },
      ],
      timestamp: '2022-11-08T15:28:00',
      altitude: '510.10',
      angle: '12.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123260,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330114,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123260,
        },
      ],
      timestamp: '2022-11-08T15:27:00',
      altitude: '510.10',
      angle: '12.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123259,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330113,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123259,
        },
      ],
      timestamp: '2022-11-08T15:26:00',
      altitude: '510.10',
      angle: '12.2',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123258,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330112,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123258,
        },
      ],
      timestamp: '2022-11-08T15:25:00',
      altitude: '509.80',
      angle: '12.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123257,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330111,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123257,
        },
      ],
      timestamp: '2022-11-08T15:24:00',
      altitude: '509.20',
      angle: '12.2',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123256,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330110,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123256,
        },
      ],
      timestamp: '2022-11-08T15:23:00',
      altitude: '508.00',
      angle: '12.2',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123255,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330109,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123255,
        },
      ],
      timestamp: '2022-11-08T15:22:00',
      altitude: '508.00',
      angle: '12.2',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123254,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330108,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123254,
        },
      ],
      timestamp: '2022-11-08T15:20:59',
      altitude: '508.00',
      angle: '12.2',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123253,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330107,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123253,
        },
      ],
      timestamp: '2022-11-08T15:19:59',
      altitude: '508.00',
      angle: '12.2',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123252,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6388666, -33.3780583],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330106,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123252,
        },
      ],
      timestamp: '2022-11-08T15:18:59',
      altitude: '507.70',
      angle: '12.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123251,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.638875, -33.3780533],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330105,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123251,
        },
      ],
      timestamp: '2022-11-08T15:17:59',
      altitude: '507.50',
      angle: '310.8',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123250,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.638605, -33.3781516],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330104,
          value: '9.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123250,
        },
      ],
      timestamp: '2022-11-08T15:16:58',
      altitude: '506.00',
      angle: '273.1',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123249,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6383883, -33.3776933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330103,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123249,
        },
      ],
      timestamp: '2022-11-08T15:16:05',
      altitude: '505.30',
      angle: '189.2',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123248,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6373466, -33.3752666],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330102,
          value: '23.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123248,
        },
      ],
      timestamp: '2022-11-08T15:15:05',
      altitude: '515.50',
      angle: '192.9',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123247,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6363833, -33.373045],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330101,
          value: '23.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123247,
        },
      ],
      timestamp: '2022-11-08T15:14:05',
      altitude: '523.80',
      angle: '204.5',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123246,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6360816, -33.3722066],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330100,
          value: '6.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123246,
        },
      ],
      timestamp: '2022-11-08T15:13:49',
      altitude: '525.80',
      angle: '143.6',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123242,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6360366, -33.3723283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330096,
          value: '21.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123242,
        },
      ],
      timestamp: '2022-11-08T15:13:25',
      altitude: '525.90',
      angle: '18.4',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123241,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6375166, -33.3759466],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330095,
          value: '29.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123241,
        },
      ],
      timestamp: '2022-11-08T15:12:25',
      altitude: '516.30',
      angle: '19.0',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123240,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6386733, -33.3788216],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330094,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123240,
        },
      ],
      timestamp: '2022-11-08T15:11:25',
      altitude: '510.60',
      angle: '16.3',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123239,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.64018, -33.3828716],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330093,
          value: '32.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123239,
        },
      ],
      timestamp: '2022-11-08T15:10:25',
      altitude: '508.10',
      angle: '353.3',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123238,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.640315, -33.3834983],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330092,
          value: '14.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123238,
        },
      ],
      timestamp: '2022-11-08T15:10:06',
      altitude: '507.90',
      angle: '54.5',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123237,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.641155, -33.38307],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330091,
          value: '7.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123237,
        },
      ],
      timestamp: '2022-11-08T15:09:37',
      altitude: '507.70',
      angle: '129.5',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123236,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.64757, -33.3799566],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330090,
          value: '89.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123236,
        },
      ],
      timestamp: '2022-11-08T15:08:37',
      altitude: '505.60',
      angle: '114.0',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123235,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6574783, -33.3762416],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330089,
          value: '109.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123235,
        },
      ],
      timestamp: '2022-11-08T15:08:02',
      altitude: '498.20',
      angle: '113.7',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123234,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.667395, -33.3724983],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330088,
          value: '107.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123234,
        },
      ],
      timestamp: '2022-11-08T15:07:30',
      altitude: '500.70',
      angle: '112.8',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123233,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6772566, -33.3688083],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330087,
          value: '99.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123233,
        },
      ],
      timestamp: '2022-11-08T15:06:53',
      altitude: '496.60',
      angle: '114.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123232,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6876983, -33.3664283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330086,
          value: '66.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123232,
        },
      ],
      timestamp: '2022-11-08T15:06:09',
      altitude: '501.90',
      angle: '95.0',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123231,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.698555, -33.3663416],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330085,
          value: '59.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123231,
        },
      ],
      timestamp: '2022-11-08T15:05:09',
      altitude: '495.70',
      angle: '40.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123230,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6971216, -33.3729883],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330084,
          value: '61.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123230,
        },
      ],
      timestamp: '2022-11-08T15:04:17',
      altitude: '494.90',
      angle: '339.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123229,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6933116, -33.381535],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330083,
          value: '98.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123229,
        },
      ],
      timestamp: '2022-11-08T15:03:34',
      altitude: '501.50',
      angle: '340.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123228,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6895416, -33.3900416],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330082,
          value: '107.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123228,
        },
      ],
      timestamp: '2022-11-08T15:03:00',
      altitude: '497.60',
      angle: '338.8',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123227,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6846733, -33.3982866],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330081,
          value: '114.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123227,
        },
      ],
      timestamp: '2022-11-08T15:02:26',
      altitude: '508.90',
      angle: '333.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123226,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6801916, -33.4065983],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330080,
          value: '110.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123226,
        },
      ],
      timestamp: '2022-11-08T15:01:54',
      altitude: '514.20',
      angle: '353.3',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123225,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6789066, -33.4157766],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330079,
          value: '103.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123225,
        },
      ],
      timestamp: '2022-11-08T15:01:20',
      altitude: '517.90',
      angle: '353.2',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123224,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6731016, -33.4235083],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330078,
          value: '90.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123224,
        },
      ],
      timestamp: '2022-11-08T15:00:40',
      altitude: '528.20',
      angle: '326.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123223,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.663815, -33.42823],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330077,
          value: '71.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123223,
        },
      ],
      timestamp: '2022-11-08T14:59:55',
      altitude: '540.20',
      angle: '296.5',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123222,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.659905, -33.4364766],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330076,
          value: '34.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123222,
        },
      ],
      timestamp: '2022-11-08T14:58:55',
      altitude: '542.30',
      angle: '350.5',
      satellites: 14,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123221,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.65961, -33.4378483],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330075,
          value: '5.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123221,
        },
      ],
      timestamp: '2022-11-08T14:57:55',
      altitude: '541.10',
      angle: '350.1',
      satellites: 12,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123220,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6594366, -33.43933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330074,
          value: '16.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123220,
        },
      ],
      timestamp: '2022-11-08T14:56:54',
      altitude: '542.80',
      angle: '353.6',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123219,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.659395, -33.43968],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330073,
          value: '7.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123219,
        },
      ],
      timestamp: '2022-11-08T14:55:54',
      altitude: '542.40',
      angle: '354.7',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123218,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6596633, -33.4414483],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330072,
          value: '21.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123218,
        },
      ],
      timestamp: '2022-11-08T14:54:54',
      altitude: '540.10',
      angle: '15.1',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123217,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6607316, -33.4417216],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330071,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123217,
        },
      ],
      timestamp: '2022-11-08T14:53:55',
      altitude: '537.10',
      angle: '78.8',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123216,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6620183, -33.4418666],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330070,
          value: '7.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123216,
        },
      ],
      timestamp: '2022-11-08T14:52:55',
      altitude: '539.10',
      angle: '59.8',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123215,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6620316, -33.441955],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330069,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123215,
        },
      ],
      timestamp: '2022-11-08T14:52:26',
      altitude: '538.70',
      angle: '347.9',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123214,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6616783, -33.4447983],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330068,
          value: '15.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123214,
        },
      ],
      timestamp: '2022-11-08T14:51:26',
      altitude: '541.10',
      angle: '350.7',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123213,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6616183, -33.44507],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330067,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123213,
        },
      ],
      timestamp: '2022-11-08T14:50:26',
      altitude: '540.50',
      angle: '1.1',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123212,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6616183, -33.44507],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330066,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123212,
        },
      ],
      timestamp: '2022-11-08T14:49:26',
      altitude: '540.50',
      angle: '1.1',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123211,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.66162, -33.4450633],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330065,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123211,
        },
      ],
      timestamp: '2022-11-08T14:48:26',
      altitude: '540.50',
      angle: '1.1',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123210,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.66162, -33.4450616],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330064,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123210,
        },
      ],
      timestamp: '2022-11-08T14:47:26',
      altitude: '540.80',
      angle: '1.1',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123209,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6616233, -33.4450616],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330063,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123209,
        },
      ],
      timestamp: '2022-11-08T14:46:26',
      altitude: '541.20',
      angle: '1.1',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123208,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6616233, -33.4450633],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330062,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123208,
        },
      ],
      timestamp: '2022-11-08T14:45:26',
      altitude: '541.40',
      angle: '1.1',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123207,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6616216, -33.4450633],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330061,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123207,
        },
      ],
      timestamp: '2022-11-08T14:44:26',
      altitude: '541.20',
      angle: '1.1',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123206,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.66163, -33.4451133],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330060,
          value: '9.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123206,
        },
      ],
      timestamp: '2022-11-08T14:43:26',
      altitude: '542.00',
      angle: '10.6',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123204,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.66089, -33.4459816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330058,
          value: '15.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123204,
        },
      ],
      timestamp: '2022-11-08T14:42:38',
      altitude: '550.20',
      angle: '238.3',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123203,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6608816, -33.4451833],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330057,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123203,
        },
      ],
      timestamp: '2022-11-08T14:41:57',
      altitude: '555.20',
      angle: '176.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123202,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6608783, -33.4451833],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330056,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123202,
        },
      ],
      timestamp: '2022-11-08T14:40:56',
      altitude: '555.60',
      angle: '176.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123201,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6609916, -33.4445566],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330055,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123201,
        },
      ],
      timestamp: '2022-11-08T14:39:56',
      altitude: '559.40',
      angle: '169.5',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123200,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6609983, -33.4445216],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330054,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123200,
        },
      ],
      timestamp: '2022-11-08T14:38:56',
      altitude: '560.50',
      angle: '172.1',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123199,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6610566, -33.444145],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330053,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123199,
        },
      ],
      timestamp: '2022-11-08T14:37:56',
      altitude: '554.60',
      angle: '182.3',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123198,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.65999, -33.4400016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330052,
          value: '40.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123198,
        },
      ],
      timestamp: '2022-11-08T14:36:56',
      altitude: '557.50',
      angle: '189.7',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123197,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.66101, -33.4323683],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330051,
          value: '54.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123197,
        },
      ],
      timestamp: '2022-11-08T14:35:55',
      altitude: '566.40',
      angle: '185.8',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123196,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6607366, -33.4279833],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330050,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123196,
        },
      ],
      timestamp: '2022-11-08T14:34:55',
      altitude: '557.20',
      angle: '170.6',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123195,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6610016, -33.4270266],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330049,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123195,
        },
      ],
      timestamp: '2022-11-08T14:33:55',
      altitude: '554.60',
      angle: '156.9',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123194,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6619466, -33.424275],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330048,
          value: '20.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123194,
        },
      ],
      timestamp: '2022-11-08T14:32:55',
      altitude: '552.90',
      angle: '163.9',
      satellites: 15,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123193,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.65977, -33.4237066],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330047,
          value: '19.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123193,
        },
      ],
      timestamp: '2022-11-08T14:31:58',
      altitude: '555.30',
      angle: '226.0',
      satellites: 13,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123192,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6600616, -33.4223966],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330046,
          value: '18.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123192,
        },
      ],
      timestamp: '2022-11-08T14:31:37',
      altitude: '553.80',
      angle: '164.8',
      satellites: 13,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123191,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586833, -33.4210383],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330045,
          value: '8.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123191,
        },
      ],
      timestamp: '2022-11-08T14:30:38',
      altitude: '564.50',
      angle: '224.0',
      satellites: 11,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123190,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6587016, -33.420945],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330044,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123190,
        },
      ],
      timestamp: '2022-11-08T14:30:10',
      altitude: '570.50',
      angle: '152.8',
      satellites: 11,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123188,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586, -33.4207933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330042,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123188,
        },
      ],
      timestamp: '2022-11-08T14:29:10',
      altitude: '585.10',
      angle: '187.8',
      satellites: 8,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123187,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.658585, -33.4205633],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330041,
          value: '9.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123187,
        },
      ],
      timestamp: '2022-11-08T14:28:30',
      altitude: '587.00',
      angle: '166.1',
      satellites: 7,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123186,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586133, -33.420175],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330040,
          value: '6.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123186,
        },
      ],
      timestamp: '2022-11-08T14:28:11',
      altitude: '590.90',
      angle: '198.2',
      satellites: 6,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123184,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586566, -33.4201833],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330037,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123184,
        },
      ],
      timestamp: '2022-11-08T14:27:30',
      altitude: '564.40',
      angle: '0.0',
      satellites: 5,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123182,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586966, -33.4202166],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330036,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123182,
        },
      ],
      timestamp: '2022-11-08T14:06:26',
      altitude: '544.30',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123181,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586966, -33.4202166],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330035,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123181,
        },
      ],
      timestamp: '2022-11-08T14:05:25',
      altitude: '544.30',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123180,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586966, -33.4202166],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330034,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123180,
        },
      ],
      timestamp: '2022-11-08T14:04:25',
      altitude: '544.30',
      angle: '301.0',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123179,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586966, -33.4202166],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330033,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123179,
        },
      ],
      timestamp: '2022-11-08T14:03:25',
      altitude: '544.30',
      angle: '301.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123178,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586966, -33.4202166],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330032,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123178,
        },
      ],
      timestamp: '2022-11-08T14:02:26',
      altitude: '544.30',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123177,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586966, -33.4202166],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330031,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123177,
        },
      ],
      timestamp: '2022-11-08T14:01:25',
      altitude: '544.30',
      angle: '301.0',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123176,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586966, -33.4202166],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330030,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123176,
        },
      ],
      timestamp: '2022-11-08T14:00:25',
      altitude: '544.30',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123174,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4201966],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330028,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123174,
        },
      ],
      timestamp: '2022-11-08T13:59:25',
      altitude: '561.50',
      angle: '301.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123173,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4201966],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330027,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123173,
        },
      ],
      timestamp: '2022-11-08T13:58:25',
      altitude: '561.50',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123172,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4201966],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330026,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123172,
        },
      ],
      timestamp: '2022-11-08T13:57:25',
      altitude: '561.50',
      angle: '301.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123171,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4201966],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330025,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123171,
        },
      ],
      timestamp: '2022-11-08T13:56:25',
      altitude: '561.50',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123170,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4201966],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330024,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123170,
        },
      ],
      timestamp: '2022-11-08T13:55:24',
      altitude: '561.50',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123169,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4201966],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330023,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123169,
        },
      ],
      timestamp: '2022-11-08T13:54:24',
      altitude: '561.50',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123168,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4201983],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330022,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123168,
        },
      ],
      timestamp: '2022-11-08T13:53:24',
      altitude: '563.50',
      angle: '301.0',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123167,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4201983],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330021,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123167,
        },
      ],
      timestamp: '2022-11-08T13:52:24',
      altitude: '563.50',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123166,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330020,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123166,
        },
      ],
      timestamp: '2022-11-08T13:51:24',
      altitude: '563.90',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123165,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330019,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123165,
        },
      ],
      timestamp: '2022-11-08T13:50:24',
      altitude: '563.90',
      angle: '301.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123164,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330018,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123164,
        },
      ],
      timestamp: '2022-11-08T13:49:24',
      altitude: '563.90',
      angle: '301.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123163,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330017,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123163,
        },
      ],
      timestamp: '2022-11-08T13:48:24',
      altitude: '563.90',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123162,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330016,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123162,
        },
      ],
      timestamp: '2022-11-08T13:47:24',
      altitude: '564.40',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123161,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330015,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123161,
        },
      ],
      timestamp: '2022-11-08T13:46:24',
      altitude: '564.40',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123160,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330014,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123160,
        },
      ],
      timestamp: '2022-11-08T13:45:24',
      altitude: '564.40',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123159,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330013,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123159,
        },
      ],
      timestamp: '2022-11-08T13:44:24',
      altitude: '564.40',
      angle: '301.0',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123158,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330012,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123158,
        },
      ],
      timestamp: '2022-11-08T13:43:24',
      altitude: '564.40',
      angle: '301.0',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123157,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330011,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123157,
        },
      ],
      timestamp: '2022-11-08T13:42:24',
      altitude: '564.40',
      angle: '301.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123156,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330010,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123156,
        },
      ],
      timestamp: '2022-11-08T13:41:24',
      altitude: '564.40',
      angle: '301.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123155,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330009,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123155,
        },
      ],
      timestamp: '2022-11-08T13:40:24',
      altitude: '564.90',
      angle: '301.0',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123154,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330008,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123154,
        },
      ],
      timestamp: '2022-11-08T13:39:24',
      altitude: '564.90',
      angle: '301.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123153,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330007,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123153,
        },
      ],
      timestamp: '2022-11-08T13:38:24',
      altitude: '564.90',
      angle: '301.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123152,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330006,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123152,
        },
      ],
      timestamp: '2022-11-08T13:37:24',
      altitude: '564.90',
      angle: '301.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123151,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330005,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123151,
        },
      ],
      timestamp: '2022-11-08T13:36:24',
      altitude: '564.90',
      angle: '301.0',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123150,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330004,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123150,
        },
      ],
      timestamp: '2022-11-08T13:35:24',
      altitude: '564.90',
      angle: '301.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123149,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586883, -33.4202016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330003,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123149,
        },
      ],
      timestamp: '2022-11-08T13:34:24',
      altitude: '564.90',
      angle: '301.0',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123148,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.658685, -33.4202083],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330002,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123148,
        },
      ],
      timestamp: '2022-11-08T13:33:24',
      altitude: '564.90',
      angle: '172.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123147,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586866, -33.420205],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330001,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123147,
        },
      ],
      timestamp: '2022-11-08T13:32:24',
      altitude: '566.10',
      angle: '172.7',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123146,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586866, -33.4202033],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 330000,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123146,
        },
      ],
      timestamp: '2022-11-08T13:31:24',
      altitude: '565.30',
      angle: '172.7',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123145,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586866, -33.4202033],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329999,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123145,
        },
      ],
      timestamp: '2022-11-08T13:30:24',
      altitude: '565.30',
      angle: '172.7',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123144,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586866, -33.4202033],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329998,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123144,
        },
      ],
      timestamp: '2022-11-08T13:29:23',
      altitude: '565.30',
      angle: '172.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123143,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586866, -33.4202033],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329997,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123143,
        },
      ],
      timestamp: '2022-11-08T13:28:23',
      altitude: '565.30',
      angle: '172.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123142,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.65869, -33.420205],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329996,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123142,
        },
      ],
      timestamp: '2022-11-08T13:27:23',
      altitude: '567.00',
      angle: '172.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123141,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586583, -33.4202083],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329995,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123141,
        },
      ],
      timestamp: '2022-11-08T13:26:23',
      altitude: '547.20',
      angle: '172.7',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123140,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586583, -33.4202083],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329994,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123140,
        },
      ],
      timestamp: '2022-11-08T13:25:23',
      altitude: '547.20',
      angle: '172.7',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123138,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586916, -33.420195],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329992,
          value: '6.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123138,
        },
      ],
      timestamp: '2022-11-08T13:24:09',
      altitude: '549.70',
      angle: '289.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123136,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6587183, -33.4202783],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329990,
          value: '6.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123136,
        },
      ],
      timestamp: '2022-11-08T13:23:54',
      altitude: '550.90',
      angle: '70.0',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123135,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6586316, -33.4208483],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329989,
          value: '6.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123135,
        },
      ],
      timestamp: '2022-11-08T13:23:33',
      altitude: '548.20',
      angle: '353.7',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123134,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581433, -33.4208933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329988,
          value: '8.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123134,
        },
      ],
      timestamp: '2022-11-08T13:23:13',
      altitude: '550.00',
      angle: '286.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123133,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581233, -33.4209266],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329987,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123133,
        },
      ],
      timestamp: '2022-11-08T13:22:17',
      altitude: '548.70',
      angle: '217.7',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123132,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.658125, -33.4209283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329986,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123132,
        },
      ],
      timestamp: '2022-11-08T13:21:17',
      altitude: '548.60',
      angle: '217.7',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123131,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.658125, -33.42093],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329985,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123131,
        },
      ],
      timestamp: '2022-11-08T13:20:17',
      altitude: '548.60',
      angle: '217.7',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123130,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.658125, -33.42093],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329984,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123130,
        },
      ],
      timestamp: '2022-11-08T13:19:16',
      altitude: '548.50',
      angle: '217.7',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123129,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581266, -33.42093],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329983,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123129,
        },
      ],
      timestamp: '2022-11-08T13:18:16',
      altitude: '548.00',
      angle: '217.7',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123128,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581266, -33.42093],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329982,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123128,
        },
      ],
      timestamp: '2022-11-08T13:17:16',
      altitude: '547.90',
      angle: '217.7',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123127,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581283, -33.42093],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329981,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123127,
        },
      ],
      timestamp: '2022-11-08T13:16:16',
      altitude: '547.40',
      angle: '217.7',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123126,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581283, -33.42093],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329980,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123126,
        },
      ],
      timestamp: '2022-11-08T13:15:15',
      altitude: '547.40',
      angle: '217.7',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123125,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581266, -33.4209316],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329979,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123125,
        },
      ],
      timestamp: '2022-11-08T13:14:15',
      altitude: '547.20',
      angle: '217.7',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123124,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581266, -33.4209316],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329978,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123124,
        },
      ],
      timestamp: '2022-11-08T13:13:15',
      altitude: '547.20',
      angle: '217.7',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123123,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581266, -33.4209316],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329977,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123123,
        },
      ],
      timestamp: '2022-11-08T13:12:15',
      altitude: '547.20',
      angle: '217.7',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123122,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581266, -33.4209316],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329976,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123122,
        },
      ],
      timestamp: '2022-11-08T13:11:15',
      altitude: '547.30',
      angle: '217.7',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123121,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581283, -33.4209283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329975,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123121,
        },
      ],
      timestamp: '2022-11-08T13:10:15',
      altitude: '547.10',
      angle: '217.7',
      satellites: 16,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123120,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581283, -33.42093],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329974,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123120,
        },
      ],
      timestamp: '2022-11-08T13:09:15',
      altitude: '547.20',
      angle: '217.7',
      satellites: 15,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123119,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581233, -33.4209283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329973,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123119,
        },
      ],
      timestamp: '2022-11-08T13:08:15',
      altitude: '547.30',
      angle: '217.7',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123118,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581233, -33.42093],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329972,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123118,
        },
      ],
      timestamp: '2022-11-08T13:07:16',
      altitude: '547.10',
      angle: '217.7',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123117,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6581266, -33.42093],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329971,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123117,
        },
      ],
      timestamp: '2022-11-08T13:06:15',
      altitude: '546.20',
      angle: '217.7',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123116,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.658125, -33.4209283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329970,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123116,
        },
      ],
      timestamp: '2022-11-08T13:05:15',
      altitude: '545.60',
      angle: '217.7',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123115,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6576433, -33.4208466],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329969,
          value: '7.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123115,
        },
      ],
      timestamp: '2022-11-08T13:04:15',
      altitude: '544.60',
      angle: '297.7',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123114,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6572216, -33.4222216],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329968,
          value: '11.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123114,
        },
      ],
      timestamp: '2022-11-08T13:03:24',
      altitude: '550.50',
      angle: '17.9',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123113,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.657835, -33.4223966],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329967,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123113,
        },
      ],
      timestamp: '2022-11-08T13:02:36',
      altitude: '550.00',
      angle: '94.4',
      satellites: 18,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123112,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.65806, -33.4224283],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329966,
          value: '2.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123112,
        },
      ],
      timestamp: '2022-11-08T13:01:36',
      altitude: '546.30',
      angle: '78.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123111,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6621483, -33.4232883],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329965,
          value: '16.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123111,
        },
      ],
      timestamp: '2022-11-08T13:00:36',
      altitude: '543.30',
      angle: '60.4',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123110,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6615766, -33.4251616],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329964,
          value: '26.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123110,
        },
      ],
      timestamp: '2022-11-08T13:00:05',
      altitude: '541.40',
      angle: '343.7',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123108,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6610333, -33.4282766],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329962,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123108,
        },
      ],
      timestamp: '2022-11-08T12:58:51',
      altitude: '548.30',
      angle: '70.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123105,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.657405, -33.4304783],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329959,
          value: '34.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123105,
        },
      ],
      timestamp: '2022-11-08T12:57:11',
      altitude: '513.00',
      angle: '292.9',
      satellites: 6,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123104,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.635725, -33.4348416],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329958,
          value: '25.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123104,
        },
      ],
      timestamp: '2022-11-08T12:55:07',
      altitude: '579.60',
      angle: '280.3',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123103,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.635495, -33.43536],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329957,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123103,
        },
      ],
      timestamp: '2022-11-08T12:54:47',
      altitude: '578.20',
      angle: '346.0',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123102,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6353366, -33.43666],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329956,
          value: '13.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123102,
        },
      ],
      timestamp: '2022-11-08T12:53:47',
      altitude: '577.80',
      angle: '344.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123101,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6342266, -33.4366666],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329955,
          value: '10.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123101,
        },
      ],
      timestamp: '2022-11-08T12:53:05',
      altitude: '578.50',
      angle: '273.3',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123100,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63418, -33.4366883],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329954,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123100,
        },
      ],
      timestamp: '2022-11-08T12:52:46',
      altitude: '578.30',
      angle: '336.8',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123098,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.634975, -33.437235],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329952,
          value: '30.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123098,
        },
      ],
      timestamp: '2022-11-08T12:51:36',
      altitude: '577.30',
      angle: '85.2',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123096,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.640265, -33.44009],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329950,
          value: '22.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123096,
        },
      ],
      timestamp: '2022-11-08T12:50:36',
      altitude: '574.60',
      angle: '37.5',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123095,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6375516, -33.443345],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329949,
          value: '6.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123095,
        },
      ],
      timestamp: '2022-11-08T12:49:36',
      altitude: '568.10',
      angle: '342.7',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123094,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6371483, -33.44408],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329948,
          value: '25.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123094,
        },
      ],
      timestamp: '2022-11-08T12:48:36',
      altitude: '568.40',
      angle: '335.7',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123093,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6354516, -33.447565],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329947,
          value: '16.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123093,
        },
      ],
      timestamp: '2022-11-08T12:47:36',
      altitude: '567.80',
      angle: '0.0',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123092,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6345483, -33.4510266],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329946,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123092,
        },
      ],
      timestamp: '2022-11-08T12:46:36',
      altitude: '565.40',
      angle: '36.9',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123091,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63443, -33.4515016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329945,
          value: '25.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123091,
        },
      ],
      timestamp: '2022-11-08T12:45:36',
      altitude: '564.70',
      angle: '341.9',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123090,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6334183, -33.4516683],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329944,
          value: '6.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123090,
        },
      ],
      timestamp: '2022-11-08T12:45:10',
      altitude: '564.50',
      angle: '278.6',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123089,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6332616, -33.4519733],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329943,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123089,
        },
      ],
      timestamp: '2022-11-08T12:44:39',
      altitude: '563.70',
      angle: '340.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123088,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63315, -33.45244],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329942,
          value: '15.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123088,
        },
      ],
      timestamp: '2022-11-08T12:43:39',
      altitude: '562.60',
      angle: '6.2',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123087,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.63453, -33.452745],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329941,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123087,
        },
      ],
      timestamp: '2022-11-08T12:42:57',
      altitude: '560.60',
      angle: '77.6',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123086,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6399616, -33.4537666],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329940,
          value: '20.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123086,
        },
      ],
      timestamp: '2022-11-08T12:41:57',
      altitude: '555.30',
      angle: '80.4',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123085,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.64414, -33.4544866],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329939,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123085,
        },
      ],
      timestamp: '2022-11-08T12:40:57',
      altitude: '551.80',
      angle: '81.7',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123084,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6466833, -33.45492],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329938,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123084,
        },
      ],
      timestamp: '2022-11-08T12:39:57',
      altitude: '549.90',
      angle: '59.6',
      satellites: 20,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123083,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6478183, -33.4551466],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329937,
          value: '30.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123083,
        },
      ],
      timestamp: '2022-11-08T12:38:57',
      altitude: '549.40',
      angle: '74.6',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123082,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6507466, -33.4555933],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329936,
          value: '30.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123082,
        },
      ],
      timestamp: '2022-11-08T12:37:57',
      altitude: '547.40',
      angle: '86.2',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123081,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6543783, -33.456025],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329935,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123081,
        },
      ],
      timestamp: '2022-11-08T12:36:57',
      altitude: '545.50',
      angle: '72.6',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123079,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.65669, -33.4567233],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329933,
          value: '19.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123079,
        },
      ],
      timestamp: '2022-11-08T12:35:50',
      altitude: '540.50',
      angle: '353.9',
      satellites: 15,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123078,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.656385, -33.46191],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329932,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123078,
        },
      ],
      timestamp: '2022-11-08T12:34:50',
      altitude: '537.60',
      angle: '359.5',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123077,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6563233, -33.46294],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329931,
          value: '23.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123077,
        },
      ],
      timestamp: '2022-11-08T12:33:50',
      altitude: '535.50',
      angle: '357.0',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123076,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.656, -33.4705483],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329930,
          value: '16.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123076,
        },
      ],
      timestamp: '2022-11-08T12:32:50',
      altitude: '530.70',
      angle: '357.4',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123075,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.655725, -33.47169],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329929,
          value: '65.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123075,
        },
      ],
      timestamp: '2022-11-08T12:31:50',
      altitude: '529.10',
      angle: '332.3',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123074,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6552916, -33.4777866],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329928,
          value: '26.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123074,
        },
      ],
      timestamp: '2022-11-08T12:30:50',
      altitude: '537.00',
      angle: '348.0',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123072,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6547816, -33.4778183],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329926,
          value: '11.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123072,
        },
      ],
      timestamp: '2022-11-08T12:30:37',
      altitude: '532.20',
      angle: '215.9',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123069,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.65539, -33.4774216],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329923,
          value: '6.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123069,
        },
      ],
      timestamp: '2022-11-08T12:30:10',
      altitude: '528.50',
      angle: '168.5',
      satellites: 14,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123068,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6563916, -33.4773883],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329922,
          value: '17.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123068,
        },
      ],
      timestamp: '2022-11-08T12:29:33',
      altitude: '529.30',
      angle: '87.9',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123067,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6574416, -33.47744],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329921,
          value: '8.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123067,
        },
      ],
      timestamp: '2022-11-08T12:28:33',
      altitude: '529.40',
      angle: '75.3',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123066,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6628433, -33.4763016],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329920,
          value: '45.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123066,
        },
      ],
      timestamp: '2022-11-08T12:27:33',
      altitude: '527.20',
      angle: '88.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123065,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6663033, -33.4765916],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329919,
          value: '2.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123065,
        },
      ],
      timestamp: '2022-11-08T12:26:33',
      altitude: '525.00',
      angle: '87.3',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123064,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.6765816, -33.4769883],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329918,
          value: '105.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123064,
        },
      ],
      timestamp: '2022-11-08T12:25:33',
      altitude: '522.20',
      angle: '92.2',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123063,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.68762, -33.477085],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329917,
          value: '105.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123063,
        },
      ],
      timestamp: '2022-11-08T12:25:02',
      altitude: '514.50',
      angle: '76.7',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123062,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.69818, -33.4797333],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329916,
          value: '111.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123062,
        },
      ],
      timestamp: '2022-11-08T12:24:31',
      altitude: '503.30',
      angle: '69.6',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123061,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.708785, -33.48203],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329915,
          value: '102.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123061,
        },
      ],
      timestamp: '2022-11-08T12:23:54',
      altitude: '491.10',
      angle: '76.3',
      satellites: 24,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123060,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.719605, -33.483665],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329914,
          value: '113.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123060,
        },
      ],
      timestamp: '2022-11-08T12:23:24',
      altitude: '480.50',
      angle: '86.9',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123059,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7307, -33.4841533],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329913,
          value: '119.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123059,
        },
      ],
      timestamp: '2022-11-08T12:22:50',
      altitude: '486.00',
      angle: '84.7',
      satellites: 23,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123058,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.74154, -33.4850983],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329912,
          value: '118.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123058,
        },
      ],
      timestamp: '2022-11-08T12:22:20',
      altitude: '478.20',
      angle: '65.9',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123057,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7496783, -33.49135],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329911,
          value: '25.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123057,
        },
      ],
      timestamp: '2022-11-08T12:21:25',
      altitude: '480.00',
      angle: '33.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123054,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7489783, -33.49163],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329908,
          value: '30.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123054,
        },
      ],
      timestamp: '2022-11-08T12:21:08',
      altitude: '484.90',
      angle: '200.4',
      satellites: 22,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123053,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7515683, -33.4883133],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329907,
          value: '49.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123053,
        },
      ],
      timestamp: '2022-11-08T12:20:31',
      altitude: '487.60',
      angle: '139.1',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123052,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.752965, -33.484295],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329906,
          value: '10.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123052,
        },
      ],
      timestamp: '2022-11-08T12:19:31',
      altitude: '481.10',
      angle: '155.2',
      satellites: 21,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123051,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.75583, -33.47922],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329905,
          value: '27.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123051,
        },
      ],
      timestamp: '2022-11-08T12:18:31',
      altitude: '484.20',
      angle: '155.4',
      satellites: 19,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123050,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7561383, -33.479125],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329904,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123050,
        },
      ],
      timestamp: '2022-11-08T12:17:49',
      altitude: '484.20',
      angle: '84.8',
      satellites: 17,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123049,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7571216, -33.4791433],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329903,
          value: '0.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123049,
        },
      ],
      timestamp: '2022-11-08T12:16:49',
      altitude: '481.80',
      angle: '86.1',
      satellites: 15,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123048,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7609333, -33.4812733],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329902,
          value: '54.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123048,
        },
      ],
      timestamp: '2022-11-08T12:15:49',
      altitude: '479.80',
      angle: '51.6',
      satellites: 12,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123047,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7666016, -33.4851033],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329901,
          value: '17.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123047,
        },
      ],
      timestamp: '2022-11-08T12:14:49',
      altitude: '477.30',
      angle: '47.7',
      satellites: 8,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123044,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7660716, -33.4866533],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329898,
          value: '10.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123044,
        },
      ],
      timestamp: '2022-11-08T12:14:15',
      altitude: '473.40',
      angle: '351.8',
      satellites: 7,
      place: 'OnRoute',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
  {
    id: 123041,
    type: 'Feature',
    geometry: {
      type: 'Point',
      coordinates: [-70.7649933, -33.4875816],
    },
    properties: {
      vehicle: 'RRZC69',
      samples: [
        {
          id: 329895,
          value: '9.000',
          source: 'GPS',
          measurand: 'Velocity',
          log: 123041,
        },
      ],
      timestamp: '2022-11-08T12:13:45',
      altitude: '469.10',
      angle: '2.1',
      satellites: 6,
      place: 'InStation',
      tracker: '860186054151952',
      latest_station: 13,
      path: 554,
    },
  },
];
